export const DirectorDetails = {
  title: '',
  firstName: '',
  surName: '',
  msisdn: '',
  email: '',
  idNumber: '',
  idType: 'id',
  positionInCompany: '',
  isIdVerified: false
};
